export enum operations {
    UPDATE = 'UPDATE', CREATE = 'CREATE'
}

export enum absence_tabs{
    ABSENCE_PAGE_MYREQUEST = 'TALEPLERIM' ,
    ABSENCE_PAGE_MYAPPROVED = 'ONAYLADIKLARIM' ,
    ABSENCE_PAGE_WAIT_MYAPPROVALS = 'ONAY_BEKLEYENLER' ,
    ABSENCE_PAGE_MYREJECT = 'REDDETTIKLERIM' ,
    ABSENCE_PAGE_ALL = 'TUMIZINLER' ,
}